<template>
  <div>
    <div class="text-general">
      <b-row class="mx-0 score-board">
        <b-col
          class="px-2 text-white d-flex justify-content-between border-right border-white"
          :style="$store.state.backgroundSecondary"
          ><label class="pt-1">ราคาสุทธิ</label
          ><label class="pt-1"
            >{{ transaction.netPrice | numeral("0,0.00") }} บาท</label
          >
        </b-col>
        <b-col
          class="px-2 text-white d-flex justify-content-between border-right border-white"
          :style="$store.state.backgroundSecondary"
          ><label class="pt-1">คะแนนรวม</label
          ><label class="pt-1"
            >{{ transaction.point | numeral("0,0") }} คะแนน</label
          >
        </b-col>
      </b-row>
      <div class="p-2 detail-panel">
        <div class="d-flex">
          <b-input-group class="panel-input-border">
            <b-form-input
              id="product-search"
              class="input-serach rounded-circle"
              placeholder="หมายเลขสมาชิก / เบอร์โทรศัพท์"
              @keypress="handlePushMessage"
              v-model="filter.search"
            ></b-form-input>
          </b-input-group>
          <b-button
            class="search-circle-bth"
            :style="$store.state.backgroundSecondary"
            ><span class="icon-input m-auto pr-2 text-white">
              <font-awesome-icon
                icon="search"
                title="View"
                @click="searchUser('search')"
              /> </span
          ></b-button>
        </div>
        <div class="mt-2">
          <div class="d-flex justify-content-between">
            <label>{{ user.first_name_th }} {{ user.last_name_th }}</label
            ><label>{{ user.point + user.center_point }} คะแนน</label>
          </div>
          <div class="d-flex justify-content-between">
            <label class="text-grey">{{ user.member_id }}</label
            ><label
              class="pointer"
              :style="`color: ${$store.state.colorSecondary}`"
              @click="openSlideCustomer"
              ><u>แก้ไขข้อมูล</u></label
            >
          </div>
        </div>
      </div>
      <div class="mt-2 p-2 detail-panel">
        <b-row class="mx-0">
          <b-col cols="6" class="pl-1 pr-2"
            ><InputText
              textFloat="รหัสพนักงาน"
              v-model="form.saleId"
              placeholder="รหัสพนักงาน"
              type="text"
              :isValidate="$v.form.saleId.$error"
              :v="$v.form.saleId"
          /></b-col>
          <b-col cols="6" class="pl-2 pr-1">
            <InputText
              textFloat="หมายเลขบิล"
              v-model="form.invoiceNo"
              placeholder="หมายเลขบิล"
              type="text"
              :isValidate="$v.form.invoiceNo.$error"
              :v="$v.form.invoiceNo"
            />
          </b-col>
        </b-row>
      </div>
      <div class="mt-2 p-2 detail-panel">
        <div class="d-flex justify-content-between">
          <div class="position-relative w-50">
            <label class="vertical-center">รายการสินค้า</label>
          </div>
          <b-button
            :disabled="!user.member_id"
            class="radius-btn text-white"
            :style="$store.state.backgroundSecondary"
            @click="openSlideProduct"
            ><font-awesome-icon
              icon="plus"
              title="create-btn"
              class="mr-0 mr-sm-1"
            /><span class="ml-1">เพิ่มสินค้า</span></b-button
          >
        </div>
        <b-row class="mx-0 mt-2">
          <b-col cols="2" class="pl-1"><span>จำนวน</span></b-col>
          <b-col cols="7"><span>รายการสินค้า</span></b-col>
          <b-col cols="3" class="pr-1 text-right"><span>ราคา</span></b-col>
        </b-row>
        <div v-if="form.product.length > 0">
          <b-row
            class="mx-0 my-1 p-2 bg-white product-panel"
            v-for="(product, index) in form.product"
            :key="index"
          >
            <b-col cols="2" class="px-2 text-center border-product"
              ><p @click="upProductQuantity(index)">
                <font-awesome-icon
                  icon="plus-circle"
                  title="up-btn"
                  class="mr-0 mr-sm-1 pointer"
                />
              </p>
              <p>{{ product.quantity }}</p>
              <p @click="downProductQuantity(index)">
                <font-awesome-icon
                  icon="minus-circle"
                  title="down-btn"
                  class="mr-0 mr-sm-1 pointer"
                /></p
            ></b-col>
            <b-col
              cols="7"
              class="px-2 pointer"
              @click="openSlideEditProduct(index)"
              ><p>{{ product.barcode }}</p>
              <p class="text-sub">{{ product.name }}</p>
            </b-col>
            <b-col
              cols="3"
              class="px-2 pointer text-right"
              @click="openSlideEditProduct(index)"
              ><p>
                {{
                  product.sap_discount.id
                    ? product.priceSap
                    : product.price | numeral("0,0.00")
                }}
              </p>
              <p v-if="product.sap_discount.id">
                <del>
                  {{ product.price | numeral("0,0.00") }}
                </del>
              </p></b-col
            >
          </b-row>
        </div>
        <div v-else class="py-4 text-grey text-center">
          <p>ไม่มีข้อมูล</p>
          <p>กรุณาเพิ่มสินค้า</p>
        </div>
      </div>
      <div class="mt-2 px-2 py-3 detail-panel">
        <div class="d-flex justify-content-between">
          <label class="ml-2">ส่วนลดท้ายบิล</label>
          <label
            class="pointer"
            :style="`color: ${$store.state.colorSecondary}`"
            @click="openSlideHeaderDiscount"
            ><u>ส่วนลดท้ายบิล</u></label
          >
        </div>
        <b-input-group class="mt-2">
          <b-form-input class="w-75" placeholder="ส่วนลดท้ายบิล"></b-form-input>
          <div
            class="w-25 bg-grey suffix-btn d-flex justify-content-center align-items-center"
          >
            บาท
          </div>
        </b-input-group>
      </div>
      <div class="mt-2 p-2 detail-panel">
        <div class="px-1 d-flex justify-content-between">
          <span>ราคารวม</span>
          <span>{{ transaction.price | numeral("0,0.00") }}</span>
        </div>
        <div class="px-1 d-flex justify-content-between">
          <span>ส่วนลดรวม</span>
          <span>{{ transaction.discount | numeral("0,0.00") }}</span>
        </div>
        <div class="px-1 d-flex justify-content-between">
          <span>ราคาสุทธิ</span>
          <span>{{ transaction.netPrice | numeral("0,0.00") }}</span>
        </div>
        <div class="px-1 d-flex justify-content-between">
          <span>คะแนนที่ได้รับ</span>
          <span>{{ transaction.point | numeral("0,0") }} คะแนน</span>
        </div>
      </div>
      <div class="mt-3 text-center">
        <b-button
          class="radius-btn text-white w-75"
          :style="$store.state.backgroundSecondary"
          @click="checkForm"
          ><span
            >ยืนยัน ({{ transaction.point | numeral("0,0") }} คะแนน)</span
          ></b-button
        ><br />
        <b-button class="text-secondary" variant="link">ลบรายการ</b-button>
      </div>
      <SlideCustomer
        ref="SlideCustomer"
        :search="filter.search"
        :user="user"
        @onChangehUser="changehUser"
        @onChangeUserData="changeUserData"
      />
      <SlideCustomerList
        ref="SlideCustomerList"
        :search="filter.search"
        @onChangehUser="changehUser"
      />
      <SlideProduct
        ref="SlideProduct"
        :booth="isBooth"
        :spa="isSpa"
        v-on:onSelectProduct="addProduct"
      />
      <SlideEditProduct
        ref="SlideEditProduct"
        :user="user"
        :headerDiscountOption="headerDiscountOption"
        :headerDiscountSelectMain="headerDiscountSelect"
        @onOpenEditHeaderDiscountModal="openModalEditHeaderDiscount"
        @onEditProduct="editProduct"
      />
      <SlideHeaderDiscount
        ref="SlideHeaderDiscount"
        :headerDiscountOption="headerDiscountOption"
        :headerDiscountSelectIdList="headerDiscountSelect"
        @onOpenEditHeaderDiscountModal="openModalEditHeaderDiscount"
        @onSelectDiscount="selectDiscount"
      />
      <b-modal
        v-model="modalConfirmShow"
        hide-header
        hide-footer
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
      >
        <label>ยืนยันการสั่งซื้อ</label>
        <div class="mt-2 p-2 detail-panel">
          <div class="px-1 d-flex justify-content-between">
            <span>ราคารวม</span>
            <span>{{ transaction.price | numeral("0,0.00") }}</span>
          </div>
          <div class="px-1 d-flex justify-content-between">
            <span>ส่วนลดรวม</span>
            <span>{{ transaction.discount | numeral("0,0.00") }}</span>
          </div>
          <div class="px-1 d-flex justify-content-between">
            <span>ราคาสุทธิ</span>
            <span>{{ transaction.netPrice | numeral("0,0.00") }}</span>
          </div>
          <div class="px-1 d-flex justify-content-between">
            <span>คะแนนที่ได้รับ</span>
            <span>{{ transaction.point | numeral("0,0") }} คะแนน</span>
          </div>
        </div>
        <b-row class="px-2 mt-3">
          <b-col cols="6" class="px-1">
            <b-button
              class="radius-btn bg-white w-100"
              :style="
                `color:${$store.state.colorSecondary};border: 1px solid ${$store.state.colorSecondary}`
              "
              @click="modalConfirmShow = false"
              ><span>ยกเลิก</span></b-button
            >
          </b-col>
          <b-col cols="6" class="px-1">
            <b-button
              class="radius-btn text-white w-100"
              :disabled="isDisabledSubmit"
              :style="$store.state.backgroundSecondary"
              @click="submitForm"
              ><span>ยืนยัน</span></b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-model="modalAlertShow"
        hide-header
        hide-footer
        size="lg"
        ref="modalAlert"
      >
        <div class="d-flex justify-content-center align-items-center">
          <label class="text-danger">{{ modalMessage }}</label>
        </div>
      </b-modal>
      <b-modal
        v-if="headerDiscountOption.length > 0"
        v-model="modalEditHeaderDiscount"
        hide-header
        hide-footer
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
      >
        <label class="text-header">ปรับส่วนลด</label>
        <div class="mt-2 p-2 detail-panel text-general">
          <b-row>
            <b-col cols="10" class="pr-0"
              ><InputText
                textFloat=""
                v-model="valueEdit"
                placeholder="0"
                type="number"
                :isValidate="$v.valueEdit.$error"
                :v="$v.valueEdit"
            /></b-col>
            <b-col cols="2" class="pl-0 pt-2 text-center"
              ><span class="text-header">{{
                headerDiscountOption[indexEdit].promotion_discount_type_id == 1
                  ? "%"
                  : "บาท"
              }}</span></b-col
            >
          </b-row>
          <p><u @click="getHeaderDisCount">กลับสู่ค่าตั้งต้น</u></p>
        </div>
        <b-row class="px-2 mt-3">
          <b-col cols="6" class="px-1">
            <b-button
              class="radius-btn bg-white w-100"
              :style="
                `color:${$store.state.colorSecondary};border: 1px solid ${$store.state.colorSecondary}`
              "
              @click="modalEditHeaderDiscount = false"
              ><span>ยกเลิก</span></b-button
            >
          </b-col>
          <b-col cols="6" class="px-1">
            <b-button
              class="radius-btn text-white w-100"
              :style="$store.state.backgroundSecondary"
              @click="editheaderDiscount"
              ><span>ยืนยัน</span></b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <ModalAlert
        ref="modalSubmitSuccess"
        text="ทำรายการสำเร็จ"
        @hadleModalAlertClose="searchUser('search')"
      />
      <ModalLoading ref="modalLoading" :hasClose="false" />
    </div>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import {
  required,
  requiredIf,
  minLength,
  minValue,
} from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import SlideCustomer from "./components/SlideCustomer.vue";
import SlideCustomerList from "./components/SlideCustomerList.vue";
import SlideProduct from "./components/SlideProduct.vue";
import SlideEditProduct from "./components/SlideEditProduct.vue";
import SlideHeaderDiscount from "./components/SlideHeaderDiscount.vue";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  name: "HomeIndex",
  components: {
    InputText,
    SlideCustomer,
    SlideCustomerList,
    SlideProduct,
    SlideEditProduct,
    SlideHeaderDiscount,
    ModalAlert,
    ModalLoading,
  },
  data() {
    return {
      isBusy: false,
      filter: {
        search: "",
      },
      user: {
        user_guid: "",
        user_id: "",
        member_id: "",
        first_name_th: "",
        last_name_th: "",
        telephone: "",
        point: 0,
        center_point: 0,
      },
      form: {
        saleId: "",
        invoiceNo: "",
        product: [],
        promotion: {
          headerDiscount: [],
        },
      },
      transaction: {
        price: 0,
        netPrice: 0,
        discount: 0,
        quantity: 0,
        point: 0,
      },
      headerDiscountSelect: [],
      headerDiscountOption: [],
      indexEdit: 0,
      valueEdit: 0,
      modalEditHeaderDiscount: false,
      isBooth: this.$cookies.get("booth") == "true",
      isSpa: this.$cookies.get("spa") == "true",
      modalConfirmShow: false,
      modalAlertShow: false,
      modalMessage: "",
      isDisabledSubmit: false,
    };
  },
  watch: {
    modalAlertShow: {
      handler(val) {
        if (this.modalAlertShow) {
          setTimeout(() => {
            this.modalAlertShow = false;
          }, 5000);
        }
      },
    },
    "form.product": {
      async handler(val) {
        this.calculateTransaction();
        if (this.form.product.length <= 0) {
          this.form.promotion.headerDiscount = await [];
          this.headerDiscountSelect = [];
        }
      },
      deep: true,
    },
    headerDiscountSelect: {
      handler(val) {
        this.calculateTransaction();
      },
      deep: true,
    },
  },
  validations: {
    form: {
      saleId: { required },
      invoiceNo: { required },
      product: { required, minLength: minLength(1) },
    },
    valueEdit: { required, minValueZero: minValue(0) },
  },
  async created() {
    this.getHeaderDisCount();
  },
  methods: {
    searchUser(type) {
      this.$refs.modalLoading.show();
      this.clearDetail();
      let body = {
        search: this.filter.search,
        datetime: moment()
          .add("years", 543)
          .format("DD/MM/YYYY HH:mm:ss"),
        skip: 0,
        take: 5,
        branch_id: this.$cookies.get("branch_id"),
      };

      this.axios
        .post(`${this.$baseUrl}/customer/searchuser`, body)
        .then((data) => {
          if (data.result == 1) {
            if (data.detail.length == 1) {
              this.user = data.detail[0];
              if (type == "changeUser") {
                setTimeout(() => {
                  this.$refs.SlideCustomer.show();
                }, 100);
              }
            } else if (data.detail.length == 0) {
              this.modalMessage = "ไม่พบสมาชิก";
              this.modalAlertShow = true;
            } else {
              this.$refs.SlideCustomerList.show();
            }
          } else {
            this.modalMessage = data.message;
            this.modalAlertShow = true;
          }
          this.$refs.modalLoading.hide();
        });
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.searchUser("search");
      }
    },
    changehUser(search, type) {
      this.filter.search = search;
      this.searchUser(type == "change" ? "changeUser" : "search");
    },
    getHeaderDisCount() {
      this.axios
        .get(
          `${this.$baseUrl}/promotion/get_header_discount/${this.$cookies.get(
            "user_guid"
          )}/${moment().format("YYYY-MM-DD HH:mm:ss")}/${this.$cookies.get(
            "branch_id"
          )}`
        )
        .then((data) => {
          this.headerDiscountOption = data.detail;
          this.valueEdit = data.detail[this.indexEdit].promotion_value;
          this.headerDiscountOption[this.indexEdit].promotion_value =
            data.detail[this.indexEdit].promotion_value;
        });
    },
    addProduct(body) {
      this.axios
        .post(`${this.$baseUrl}/product/product_lookup`, body)
        .then((data) => {
          if (data.result == 1) {
            data.detail.quantity = 1;
            data.detail.group_barcode = "";
            data.detail.sap_discount = { id: null };
            data.detail.item_discount = { id: null };
            this.form.product.push(data.detail);
          }
        });
    },
    upProductQuantity(index) {
      this.form.product[index].quantity += 1;
    },
    downProductQuantity(index) {
      if (this.form.product[index].quantity > 1) {
        this.form.product[index].quantity -= 1;
      } else {
        this.form.product.splice(index, 1);
      }
    },
    clearDetail() {
      this.user = {
        user_guid: "",
        user_id: "",
        member_id: "",
        first_name_th: "",
        last_name_th: "",
        telephone: "",
        point: 0,
        center_point: 0,
      };
      this.form = {
        saleId: "",
        invoiceNo: "",
        product: [],
        promotion: {},
      };
    },
    openSlideCustomer() {
      if (this.user.member_id) {
        this.$refs.SlideCustomer.show();
      }
    },
    openSlideProduct() {
      this.$refs.SlideProduct.show();
    },
    openSlideEditProduct(index) {
      this.$refs.SlideEditProduct.show(JSON.stringify(this.form), index);
    },
    openSlideHeaderDiscount() {
      if (this.form.product.length > 0) {
        this.$refs.SlideHeaderDiscount.show();
      }
    },
    async changeUserData(body) {
      this.axios
        .post(`${this.$baseUrl}/customer/check_duplicate_telephone`, body)
        .then((data) => {
          if (data.result == 1) {
            this.axios
              .post(`${this.$baseUrl}/customer/editdata`, body)
              .then((data) => {
                if (data.result == 1) {
                  this.user = body;
                  this.$refs.SlideCustomer.hide();
                } else {
                  this.modalMessage = data.detail;
                  this.modalAlertShow = true;
                }
              });
          } else {
            this.modalMessage = data.detail;
            this.modalAlertShow = true;
          }
        });
    },
    editProduct(detail, index) {
      this.form.product[index].price = detail.product.price
        ? parseInt(detail.product.price)
        : 0;
      this.form.product[index].quantity = parseInt(detail.product.quantity);
      this.form.product[index].sap_discount.id = detail.promotion.id;
      detail.promotion.option.forEach((p, i) => {
        if (p.id == detail.promotion.id) {
          this.form.product[index].priceSap = p.promotion_value;
        }
      });
      this.form.product[index].item_discount.id = detail.itemDiscount;
      this.selectDiscount(detail.headerDiscount);
    },
    selectDiscount(list) {
      this.headerDiscountSelect = list.id;
      this.form.promotion.headerDiscount = list.detail;
    },
    async openModalEditHeaderDiscount(index) {
      this.indexEdit = await index;
      this.valueEdit = await this.headerDiscountOption[index].promotion_value;
      this.modalEditHeaderDiscount = true;
    },
    async editheaderDiscount() {
      this.$v.valueEdit.$touch();
      if (this.$v.valueEdit.$error) {
        return;
      } else {
        this.headerDiscountOption[
          this.indexEdit
        ].promotion_value = await parseInt(this.valueEdit ? this.valueEdit : 0);
        if (this.form.promotion.headerDiscount.length >= this.indexEdit + 1) {
          this.form.promotion.headerDiscount[
            this.indexEdit
          ].custom_header_discount = await parseInt(
            this.valueEdit ? this.valueEdit : 0
          );
        }
        await this.$refs.SlideHeaderDiscount.resetCalculateList();
        await this.$refs.SlideEditProduct.resetCalculateList();
        this.$refs.modalLoading.show();
        await this.calculateTransaction();
        this.$refs.modalLoading.hide();
        this.modalEditHeaderDiscount = false;
      }
    },
    calculateTransaction() {
      let product = this.form.product.map((prod, index) => {
        return {
          id: prod.id,
          q: prod.quantity,
          custom_price: prod.price,
          group_barcode: "",
          sap_discount: prod.sap_discount.id
            ? [{ id: prod.sap_discount.id, custom_header_discount: null }]
            : null,
          item_discount: prod.item_discount.id
            ? [{ id: prod.item_discount.id, custom_header_discount: null }]
            : null,
        };
      });
      let body = {
        price: [],
        promotion: this.form.promotion.headerDiscount,
        product: product,
        credit: null,
        customer_id: this.user.user_guid,
        user_id: this.$cookies.get("user_guid"),
        user_guid: this.$cookies.get("user_guid"),
        debug: 0,
        branch_id: this.$cookies.get("branch_id"),
        t_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
      };
      this.axios
        .post(`${this.$baseUrl}/transaction/calculate_transaction_data`, body)
        .then((data) => {
          if (data.result == 1) {
            this.transaction = {
              price: data.price.price_with_no_discount,
              netPrice: data.price.price,
              discount: data.price.discount,
              quantity: data.quantity,
              point: data.center_point + data.point,
            };
          } else {
            this.transaction = {
              price: 0,
              netPrice: 0,
              discount: 0,
              quantity: 0,
              point: 0,
            };
          }
        });
    },
    checkForm() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      } else {
        this.modalConfirmShow = true;
      }
    },
    submitForm() {
      this.$refs.modalLoading.show();
      this.isDisabledSubmit = true;
      let product = this.form.product.map((prod, index) => {
        return {
          id: prod.id,
          q: prod.quantity,
          group_barcode: "",
          sap_discount: prod.sap_discount.id
            ? [{ id: prod.sap_discount.id, custom_header_discount: null }]
            : null,
          item_discount: prod.item_discount.id
            ? [{ id: prod.item_discount.id, custom_header_discount: null }]
            : null,
        };
      });
      let body = {
        price: [],
        promotion: this.form.promotion.headerDiscount,
        product: product,
        credit: null,
        user_guid: this.user.user_guid,
        debug: 0,
        branch_id: this.$cookies.get("branch_id"),
        t_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
        user_get_point: "1",
        new_customer: "0",
        tourist: "0",
        partner: "0",
        partner_detail: "",
        invoice_no: this.form.invoiceNo,
        zero_point: "0",
        sales_id: this.form.saleId,
      };
      this.axios
        .post(`${this.$baseUrl}/transaction/submit_transaction_data`, body)
        .then((data) => {
          if (data.result == 1) {
            // this.$router.go(0);
            this.modalConfirmShow = false;
            this.$refs.modalSubmitSuccess.show();
            setTimeout(() => {
              this.$refs.modalSubmitSuccess.hide();
            }, 5000);
          } else {
            this.modalConfirmShow = false;
            this.modalMessage = data.message;
            this.modalAlertShow = true;
          }
          this.$refs.modalLoading.hide();
          this.isDisabledSubmit = false;
        })
        .catch(function(error) {
          this.$refs.modalLoading.hide();
          this.isDisabledSubmit = false;
          this.modalConfirmShow = false;
          this.modalMessage = "ไม่สามารถทำรายการได้";
          this.modalAlertShow = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep label {
  font-weight: bold;
  margin-bottom: 0px;
}
::v-deep p {
  margin-bottom: 0px;
}

</style>
